const maps = [
  {
    path: '/michelin',
    image: 'michelin.png',
    title: 'Michelin',
  },
  {
    path: '/mercator',
    image: 'mercator.png',
    title: 'Mercator',
  },
  {
    path: '/electro',
    image: 'electro.png',
    title: 'Electro',
  },
]

export { maps };
